import { Beschaeftigung } from 'cpool-schemas';
import { z } from 'zod';

import { TAX_CLASSIFICATIONS_FRONTEND } from '~/constants.ts';

const defaultBeschaeftigung = z.object({
    // the only difference between the original and this one is the enum
    steuerklasse: z.nativeEnum(TAX_CLASSIFICATIONS_FRONTEND).nullish().default(null),
});

// we need to remove the default and unwrap twice to reach the options
// the two unwrap calls remove null and undefined from the type
const { discriminator, options } = Beschaeftigung.removeDefault().unwrap().unwrap();

// here we override the steuerklasse enum with the frontend one
export const BeschaeftigungOptions = options.map((option) => option.merge(defaultBeschaeftigung));

// to ensure the schema behaves like the original we need to add the default value and make it nullish
export const BeschaeftigungForm = z
    .discriminatedUnion(discriminator, [
        // we need to explicitly define one of the options so that the options always have at least one entry for ts
        BeschaeftigungOptions[0],
        ...BeschaeftigungOptions.slice(1),
    ])
    .nullish()
    .default(null);

export type Schema_BeschaeftigungForm = z.infer<typeof BeschaeftigungForm>;
